import psl_ui from '../../libs/psl_ui.js';

import data from '../../data.js';

import './style.scss';
import template from './template.pst';

import state from '../../state.js';

import {wait} from '../../libs/psl_polyfills.js';

psl_ui.templates.add('maps',template);

const {els,rpoints}=psl_ui.templates.render('maps',{map:data.eras});

const _container = document.getElementById('container');

els.forEach(el=>_container.appendChild(el));

async function _transition(){
	const prev = Array.from(Object.values(rpoints)).find(el=>el.classList.contains('active'));
	const next = rpoints[`item_${state.era}`];

	if(prev === next) return;
	
	next.classList.add('switching');
	await wait(1);
	next.classList.add('active');
	await wait(200);
	prev?.classList.remove('active');
	await wait(200);
	next.classList.remove('switching');
}

_transition();

state.events.on('era',_transition);
state.events.on('roads',()=>{
	els[0].classList.toggle('roads_hidden',!state.roads);
});
state.events.on('cities',()=>{
	els[0].classList.toggle('cities_hidden',!state.cities);
});